﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import classes from "../../maintainers.module.scss";

import Fetching from "@/components/Fetching/Fetching";

import { base_product } from "../products.constants";

import api from "@/services/api.service";
import TabFields from "./TabFields";
import TabReactivo from "./TabReactivo";
import TabURLs from "./TabURLs";
import TabWeight from "./TabWeight";
import TabActiveIngredients from "./TabActiveIngredients";
import TabUses from "./TabUses";

const ProductsForm = ({ confirmSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, product_id } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [data, setData] = useState({ ...base_product });

	useEffect(() => {
		setIsFetching(true);

		if (option && product_id && option === "editar") {
			api.get("/admin/products/detail", { product_id }).then((response) => {
				const { product } = response;
				if (product) {
					setData(product);
				} else {
					addToast("Ocurrió un problema al cargar el producto seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [product_id, option]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate(-1);
	};

	const validSave = () => {
		if (!data.name) {
			addToast("Debe ingresar un nombre del producto para guardar.", {
				appearance: "error",
			});
			return false;
		}

		if (!data.unit_measurement) {
			addToast("Debe seleccionar una unidad de medida para guardar.", {
				appearance: "error",
			});
			return false;
		}

		if (!data.country_id) {
			addToast("Debe seleccionar el país para guardar.", {
				appearance: "error",
			});
			return false;
		}

		const response = data.weights.map((weight) => {
			const count_weight = data.weights.filter((w) => Number(w.container_content) === Number(weight.container_content));
			if (count_weight.length > 1) {
				return false;
			}
			return true;
		});

		if (!response.every((v) => v === true)) {
			addToast("Existen dos contenidos netos iguales en los pesos de envase.", {
				appearance: "error",
			});
			return false;
		}

		return true;
	};

	const afterSave = () => {
		handleClose();
		addToast("Producto guardado correctamente.", {
			appearance: "success",
		});
	};

	const handleSave = () => {
		if (validSave()) {
			const newData = { ...data, is_new: false };
			confirmSave({ form: newData }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_product });
	};

	return (
		<Modal
			show={option && ["editar", "crear"].includes(option) ? true : false}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			className={classes.main_form}
			size="xl"
		>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>
					Producto
					{data.from_sag === 1 ? (
						<span className={classes.sagMessage}> desde SAG</span>
					) : data.match_sag === 1 ? (
						<span className={classes.sagMessage}> actualizado desde SAG</span>
					) : null}
				</h4>
			</Modal.Header>
			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Tabs defaultActiveKey="detalle" id="formulario-productos" className={classes.modal_tabs}>
						<Tab eventKey="detalle" title="Formulario">
							<TabFields data={data} setData={setData} />
						</Tab>
						<Tab eventKey="reactivos" title="Reactivos Quimicos">
							<TabReactivo data={data} setData={setData} />
						</Tab>
						<Tab eventKey="etiqueta" title="URLs">
							<TabURLs data={data} setData={setData} />
						</Tab>
						<Tab eventKey="pesos" title="Peso de Envase">
							<TabWeight data={data} setData={setData} />
						</Tab>
						<Tab eventKey="ingredientesActivos" title="Ingrediente(s) activo(s)">
							<TabActiveIngredients data={data} setData={setData} />
						</Tab>
						<Tab eventKey="usos" title="Usos">
							<TabUses data={data} setData={setData} />
						</Tab>
					</Tabs>
				)}
			</Modal.Body>
			<Modal.Footer>
				{!isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default ProductsForm;
